/**
 * DO NOT EDIT THIS FILE MANUALLY
 * Generated by `Opus::GeneratedFileVerifier::Generators::DashboardData::DashboardDataCurrenciesStep`
 * If this file is out-of-sync or causing builds to fail, try running `scripts/bin/sync-generated`
 */
export type Currency = {
  priority: number,
  iso_code: string,
  name: string,
  symbol: string,
  alternate_symbols?: Array<string>,
  subunit: string | null,
  subunit_to_unit: number,
  symbol_first: boolean,
  html_entity: string,
  decimal_mark: string,
  thousands_separator: string,
  disambiguate_symbol?: string,
  smallest_denomination?: number,
  iso_numeric: string,
  subunit_symbol: string,
  postfixed_symbol: boolean,
  payout_no_decimal: boolean,
};

export type Currencies = Record<string, Currency>;

const CURRENCIES: Currencies = {
  "aed": {
    "priority": 100,
    "iso_code": "aed",
    "name": "United Arab Emirates Dirham",
    "symbol": "د.إ",
    "alternate_symbols": [
      "DH",
      "Dhs"
    ],
    "subunit": "Fils",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "784",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "afn": {
    "priority": 100,
    "iso_code": "afn",
    "name": "Afghan Afghani",
    "symbol": "؋",
    "alternate_symbols": [
      "Af",
      "Afs"
    ],
    "subunit": "Pul",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "971",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "all": {
    "priority": 100,
    "iso_code": "all",
    "name": "Albanian Lek",
    "symbol": "L",
    "alternate_symbols": [
      "Lek"
    ],
    "subunit": "Qintar",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "008",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "amd": {
    "priority": 100,
    "iso_code": "amd",
    "name": "Armenian Dram",
    "symbol": "դր.",
    "alternate_symbols": [
      "dram"
    ],
    "subunit": "Luma",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "051",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ang": {
    "priority": 100,
    "iso_code": "ang",
    "name": "Netherlands Antillean Gulden",
    "symbol": "ƒ",
    "alternate_symbols": [
      "NAƒ",
      "NAf",
      "f"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x0192;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "532",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "aoa": {
    "priority": 100,
    "iso_code": "aoa",
    "name": "Angolan Kwanza",
    "symbol": "Kz",
    "alternate_symbols": [],
    "subunit": "Cêntimo",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "973",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ars": {
    "priority": 100,
    "iso_code": "ars",
    "name": "Argentine Peso",
    "symbol": "$",
    "alternate_symbols": [
      "$m/n",
      "m$n"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20B1;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "032",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "aud": {
    "priority": 4,
    "iso_code": "aud",
    "name": "Australian Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "A$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "036",
    "subunit_symbol": "¢",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "awg": {
    "priority": 100,
    "iso_code": "awg",
    "name": "Aruban Florin",
    "symbol": "ƒ",
    "alternate_symbols": [
      "Afl"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x0192;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "533",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "azn": {
    "priority": 100,
    "iso_code": "azn",
    "name": "Azerbaijani Manat",
    "symbol": "₼",
    "alternate_symbols": [
      "m",
      "man"
    ],
    "subunit": "Qəpik",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "944",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bam": {
    "priority": 100,
    "iso_code": "bam",
    "name": "Bosnia and Herzegovina Convertible Mark",
    "symbol": "КМ",
    "alternate_symbols": [
      "KM"
    ],
    "subunit": "Fening",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "977",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bbd": {
    "priority": 100,
    "iso_code": "bbd",
    "name": "Barbadian Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "Bds$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "052",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bdt": {
    "priority": 100,
    "iso_code": "bdt",
    "name": "Bangladeshi Taka",
    "symbol": "৳",
    "alternate_symbols": [
      "Tk"
    ],
    "subunit": "Paisa",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "050",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bgn": {
    "priority": 100,
    "iso_code": "bgn",
    "name": "Bulgarian Lev",
    "symbol": "лв",
    "alternate_symbols": [
      "lev",
      "leva",
      "лев",
      "лева"
    ],
    "subunit": "Stotinka",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "975",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bhd": {
    "priority": 100,
    "iso_code": "bhd",
    "name": "Bahraini Dinar",
    "symbol": "ب.د",
    "alternate_symbols": [
      "BD"
    ],
    "subunit": "Fils",
    "subunit_to_unit": 1000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "048",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bif": {
    "priority": 100,
    "iso_code": "bif",
    "name": "Burundian Franc",
    "symbol": "Fr",
    "alternate_symbols": [
      "FBu"
    ],
    "subunit": "Centime",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "108",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bmd": {
    "priority": 100,
    "iso_code": "bmd",
    "name": "Bermudian Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "BD$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "060",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bnd": {
    "priority": 100,
    "iso_code": "bnd",
    "name": "Brunei Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "B$"
    ],
    "subunit": "Sen",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "096",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bob": {
    "priority": 100,
    "iso_code": "bob",
    "name": "Bolivian Boliviano",
    "symbol": "Bs.",
    "alternate_symbols": [
      "Bs"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "068",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "brl": {
    "priority": 100,
    "iso_code": "brl",
    "name": "Brazilian Real",
    "symbol": "R$ ",
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "R$",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "986",
    "subunit_symbol": "c",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bsd": {
    "priority": 100,
    "iso_code": "bsd",
    "name": "Bahamian Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "B$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "044",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "btn": {
    "priority": 100,
    "iso_code": "btn",
    "name": "Bhutanese Ngultrum",
    "symbol": "Nu.",
    "alternate_symbols": [
      "Nu"
    ],
    "subunit": "Chertrum",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "064",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bwp": {
    "priority": 100,
    "iso_code": "bwp",
    "name": "Botswana Pula",
    "symbol": "P",
    "alternate_symbols": [],
    "subunit": "Thebe",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "072",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "byr": {
    "priority": 100,
    "iso_code": "byr",
    "name": "Belarusian Ruble",
    "symbol": "Br",
    "alternate_symbols": [
      ""
    ],
    "subunit": "Kapyeyka",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "974",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "bzd": {
    "priority": 100,
    "iso_code": "bzd",
    "name": "Belize Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "BZ$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "084",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "cad": {
    "priority": 5,
    "iso_code": "cad",
    "name": "Canadian Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "C$",
      "CAD$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "124",
    "subunit_symbol": "¢",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "cdf": {
    "priority": 100,
    "iso_code": "cdf",
    "name": "Congolese Franc",
    "symbol": "Fr",
    "alternate_symbols": [
      "FC"
    ],
    "subunit": "Centime",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "976",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "chf": {
    "priority": 100,
    "iso_code": "chf",
    "name": "Swiss Franc",
    "symbol": "CHF ",
    "alternate_symbols": [
      "SFr",
      "CHF"
    ],
    "subunit": "Rappen",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": "'",
    "iso_numeric": "756",
    "subunit_symbol": "c",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "clf": {
    "priority": 100,
    "iso_code": "clf",
    "name": "Unidad de Fomento",
    "symbol": "UF",
    "alternate_symbols": [],
    "subunit": "Peso",
    "subunit_to_unit": 1,
    "symbol_first": true,
    "html_entity": "\u0026#x20B1;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "990",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "clp": {
    "priority": 100,
    "iso_code": "clp",
    "name": "Chilean Peso",
    "symbol": "$",
    "alternate_symbols": [],
    "subunit": "Peso",
    "subunit_to_unit": 1,
    "symbol_first": true,
    "html_entity": "\u0026#x20B1;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "152",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "cny": {
    "priority": 100,
    "iso_code": "cny",
    "name": "Chinese Renminbi Yuan",
    "symbol": "¥",
    "alternate_symbols": [
      "CN¥",
      "元",
      "CN元"
    ],
    "subunit": "Fen",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#20803;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "156",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "cop": {
    "priority": 100,
    "iso_code": "cop",
    "name": "Colombian Peso",
    "symbol": "$",
    "alternate_symbols": [
      "COL$"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20B1;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "170",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "crc": {
    "priority": 100,
    "iso_code": "crc",
    "name": "Costa Rican Colón",
    "symbol": "₡",
    "alternate_symbols": [
      "¢"
    ],
    "subunit": "Céntimo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20A1;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "188",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "cuc": {
    "priority": 100,
    "iso_code": "cuc",
    "name": "Cuban Convertible Peso",
    "symbol": "$",
    "alternate_symbols": [
      "CUC$"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "931",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "cup": {
    "priority": 100,
    "iso_code": "cup",
    "name": "Cuban Peso",
    "symbol": "$",
    "alternate_symbols": [
      "$MN"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20B1;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "192",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "cve": {
    "priority": 100,
    "iso_code": "cve",
    "name": "Cape Verdean Escudo",
    "symbol": "$",
    "alternate_symbols": [
      "Esc"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "132",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "czk": {
    "priority": 100,
    "iso_code": "czk",
    "name": "Czech Koruna",
    "symbol": "Kč",
    "alternate_symbols": [],
    "subunit": "Haléř",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "203",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "djf": {
    "priority": 100,
    "iso_code": "djf",
    "name": "Djiboutian Franc",
    "symbol": "Fdj",
    "alternate_symbols": [],
    "subunit": "Centime",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "262",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "dkk": {
    "priority": 100,
    "iso_code": "dkk",
    "name": "Danish Krone",
    "symbol": "kr",
    "alternate_symbols": [
      ",-"
    ],
    "subunit": "Øre",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "208",
    "subunit_symbol": "",
    "postfixed_symbol": true,
    "payout_no_decimal": false
  },
  "dop": {
    "priority": 100,
    "iso_code": "dop",
    "name": "Dominican Peso",
    "symbol": "$",
    "alternate_symbols": [
      "RD$"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20B1;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "214",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "dzd": {
    "priority": 100,
    "iso_code": "dzd",
    "name": "Algerian Dinar",
    "symbol": "د.ج",
    "alternate_symbols": [
      "DA"
    ],
    "subunit": "Centime",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "012",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "egp": {
    "priority": 100,
    "iso_code": "egp",
    "name": "Egyptian Pound",
    "symbol": "ج.م",
    "alternate_symbols": [
      "LE",
      "E£",
      "L.E."
    ],
    "subunit": "Piastre",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "818",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ern": {
    "priority": 100,
    "iso_code": "ern",
    "name": "Eritrean Nakfa",
    "symbol": "Nfk",
    "alternate_symbols": [],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "232",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "etb": {
    "priority": 100,
    "iso_code": "etb",
    "name": "Ethiopian Birr",
    "symbol": "Br",
    "alternate_symbols": [],
    "subunit": "Santim",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "230",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "eur": {
    "priority": 2,
    "iso_code": "eur",
    "name": "Euro",
    "symbol": "€",
    "alternate_symbols": [],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20AC;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "978",
    "subunit_symbol": "c",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "fjd": {
    "priority": 100,
    "iso_code": "fjd",
    "name": "Fijian Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "FJ$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "242",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "fkp": {
    "priority": 100,
    "iso_code": "fkp",
    "name": "Falkland Pound",
    "symbol": "£",
    "alternate_symbols": [
      "FK£"
    ],
    "subunit": "Penny",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "238",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "gbp": {
    "priority": 3,
    "iso_code": "gbp",
    "name": "British Pound",
    "symbol": "£",
    "alternate_symbols": [],
    "subunit": "Penny",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "826",
    "subunit_symbol": "p",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "gel": {
    "priority": 100,
    "iso_code": "gel",
    "name": "Georgian Lari",
    "symbol": "ლ",
    "alternate_symbols": [
      "lari"
    ],
    "subunit": "Tetri",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "981",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ghs": {
    "priority": 100,
    "iso_code": "ghs",
    "name": "Ghanaian Cedi",
    "symbol": "₵",
    "alternate_symbols": [
      "GH¢",
      "GH₵"
    ],
    "subunit": "Pesewa",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20B5;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "936",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "gip": {
    "priority": 100,
    "iso_code": "gip",
    "name": "Gibraltar Pound",
    "symbol": "£",
    "alternate_symbols": [],
    "subunit": "Penny",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "292",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "gmd": {
    "priority": 100,
    "iso_code": "gmd",
    "name": "Gambian Dalasi",
    "symbol": "D",
    "alternate_symbols": [],
    "subunit": "Butut",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "270",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "gnf": {
    "priority": 100,
    "iso_code": "gnf",
    "name": "Guinean Franc",
    "symbol": "Fr",
    "alternate_symbols": [
      "FG",
      "GFr"
    ],
    "subunit": "Centime",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "324",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "gtq": {
    "priority": 100,
    "iso_code": "gtq",
    "name": "Guatemalan Quetzal",
    "symbol": "Q",
    "alternate_symbols": [],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "320",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "gyd": {
    "priority": 100,
    "iso_code": "gyd",
    "name": "Guyanese Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "G$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "328",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "hkd": {
    "priority": 100,
    "iso_code": "hkd",
    "name": "Hong Kong Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "HK$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "344",
    "subunit_symbol": "¢",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "hnl": {
    "priority": 100,
    "iso_code": "hnl",
    "name": "Honduran Lempira",
    "symbol": "L",
    "alternate_symbols": [],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "340",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "hrk": {
    "priority": 100,
    "iso_code": "hrk",
    "name": "Croatian Kuna",
    "symbol": "kn",
    "alternate_symbols": [],
    "subunit": "Lipa",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "191",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "htg": {
    "priority": 100,
    "iso_code": "htg",
    "name": "Haitian Gourde",
    "symbol": "G",
    "alternate_symbols": [],
    "subunit": "Centime",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "332",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "huf": {
    "priority": 100,
    "iso_code": "huf",
    "name": "Hungarian Forint",
    "symbol": "Ft",
    "alternate_symbols": [],
    "subunit": "Fillér",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "348",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": true
  },
  "idr": {
    "priority": 100,
    "iso_code": "idr",
    "name": "Indonesian Rupiah",
    "symbol": "Rp",
    "alternate_symbols": [],
    "subunit": "Sen",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "360",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ils": {
    "priority": 100,
    "iso_code": "ils",
    "name": "Israeli New Sheqel",
    "symbol": "₪",
    "alternate_symbols": [
      "ש״ח",
      "NIS"
    ],
    "subunit": "Agora",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20AA;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "376",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "inr": {
    "priority": 100,
    "iso_code": "inr",
    "name": "Indian Rupee",
    "symbol": "₹",
    "alternate_symbols": [
      "Rs",
      "৳",
      "૱",
      "௹",
      "रु",
      "₨"
    ],
    "subunit": "Paisa",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20b9;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "356",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "iqd": {
    "priority": 100,
    "iso_code": "iqd",
    "name": "Iraqi Dinar",
    "symbol": "ع.د",
    "alternate_symbols": [],
    "subunit": "Fils",
    "subunit_to_unit": 1000,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "368",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "irr": {
    "priority": 100,
    "iso_code": "irr",
    "name": "Iranian Rial",
    "symbol": "﷼",
    "alternate_symbols": [],
    "subunit": "Dinar",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#xFDFC;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "364",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "isk": {
    "priority": 100,
    "iso_code": "isk",
    "name": "Icelandic Króna",
    "symbol": "kr",
    "alternate_symbols": [
      "Íkr"
    ],
    "subunit": "Eyrir",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "352",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "jmd": {
    "priority": 100,
    "iso_code": "jmd",
    "name": "Jamaican Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "J$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "388",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "jod": {
    "priority": 100,
    "iso_code": "jod",
    "name": "Jordanian Dinar",
    "symbol": "د.ا",
    "alternate_symbols": [
      "JD"
    ],
    "subunit": "Piastre",
    "subunit_to_unit": 1000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "400",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "jpy": {
    "priority": 6,
    "iso_code": "jpy",
    "name": "Japanese Yen",
    "symbol": "¥",
    "alternate_symbols": [
      "円",
      "圓"
    ],
    "subunit": null,
    "subunit_to_unit": 1,
    "symbol_first": true,
    "html_entity": "\u0026#x00A5;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "392",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "kes": {
    "priority": 100,
    "iso_code": "kes",
    "name": "Kenyan Shilling",
    "symbol": "KSh",
    "alternate_symbols": [
      "Sh"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "404",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "kgs": {
    "priority": 100,
    "iso_code": "kgs",
    "name": "Kyrgyzstani Som",
    "symbol": "som",
    "alternate_symbols": [
      "сом"
    ],
    "subunit": "Tyiyn",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "417",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "khr": {
    "priority": 100,
    "iso_code": "khr",
    "name": "Cambodian Riel",
    "symbol": "៛",
    "alternate_symbols": [],
    "subunit": "Sen",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x17DB;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "116",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "kmf": {
    "priority": 100,
    "iso_code": "kmf",
    "name": "Comorian Franc",
    "symbol": "Fr",
    "alternate_symbols": [
      "CF"
    ],
    "subunit": "Centime",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "174",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "kpw": {
    "priority": 100,
    "iso_code": "kpw",
    "name": "North Korean Won",
    "symbol": "₩",
    "alternate_symbols": [],
    "subunit": "Chŏn",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x20A9;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "408",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "krw": {
    "priority": 100,
    "iso_code": "krw",
    "name": "South Korean Won",
    "symbol": "₩",
    "subunit": null,
    "subunit_to_unit": 1,
    "alternate_symbols": [],
    "symbol_first": true,
    "html_entity": "\u0026#x20A9;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "410",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "kwd": {
    "priority": 100,
    "iso_code": "kwd",
    "name": "Kuwaiti Dinar",
    "symbol": "د.ك",
    "alternate_symbols": [
      "K.D."
    ],
    "subunit": "Fils",
    "subunit_to_unit": 1000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "414",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "kyd": {
    "priority": 100,
    "iso_code": "kyd",
    "name": "Cayman Islands Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "CI$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "136",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "kzt": {
    "priority": 100,
    "iso_code": "kzt",
    "name": "Kazakhstani Tenge",
    "symbol": "〒",
    "alternate_symbols": [],
    "subunit": "Tiyn",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "398",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "lak": {
    "priority": 100,
    "iso_code": "lak",
    "name": "Lao Kip",
    "symbol": "₭",
    "alternate_symbols": [
      "₭N"
    ],
    "subunit": "Att",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x20AD;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "418",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "lbp": {
    "priority": 100,
    "iso_code": "lbp",
    "name": "Lebanese Pound",
    "symbol": "ل.ل",
    "alternate_symbols": [
      "£",
      "L£"
    ],
    "subunit": "Piastre",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "422",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "lkr": {
    "priority": 100,
    "iso_code": "lkr",
    "name": "Sri Lankan Rupee",
    "symbol": "₨",
    "alternate_symbols": [
      "රු",
      "ரூ",
      "SLRs",
      "/-"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x0BF9;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "144",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "lrd": {
    "priority": 100,
    "iso_code": "lrd",
    "name": "Liberian Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "L$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "430",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "lsl": {
    "priority": 100,
    "iso_code": "lsl",
    "name": "Lesotho Loti",
    "symbol": "L",
    "alternate_symbols": [
      "M"
    ],
    "subunit": "Sente",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "426",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ltl": {
    "priority": 100,
    "iso_code": "ltl",
    "name": "Lithuanian Litas",
    "symbol": "Lt",
    "alternate_symbols": [],
    "subunit": "Centas",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "440",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "lvl": {
    "priority": 100,
    "iso_code": "lvl",
    "name": "Latvian Lats",
    "symbol": "Ls",
    "alternate_symbols": [],
    "subunit": "Santīms",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "428",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "lyd": {
    "priority": 100,
    "iso_code": "lyd",
    "name": "Libyan Dinar",
    "symbol": "ل.د",
    "alternate_symbols": [
      "LD"
    ],
    "subunit": "Dirham",
    "subunit_to_unit": 1000,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "434",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mad": {
    "priority": 100,
    "iso_code": "mad",
    "name": "Moroccan Dirham",
    "symbol": "د.م.",
    "alternate_symbols": [],
    "subunit": "Centime",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "504",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mdl": {
    "priority": 100,
    "iso_code": "mdl",
    "name": "Moldovan Leu",
    "symbol": "L",
    "alternate_symbols": [
      "lei"
    ],
    "subunit": "Ban",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "498",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mga": {
    "priority": 100,
    "iso_code": "mga",
    "name": "Malagasy Ariary",
    "symbol": "Ar",
    "alternate_symbols": [],
    "subunit": "Iraimbilanja",
    "subunit_to_unit": 1,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "969",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mkd": {
    "priority": 100,
    "iso_code": "mkd",
    "name": "Macedonian Denar",
    "symbol": "ден",
    "alternate_symbols": [],
    "subunit": "Deni",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "807",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mmk": {
    "priority": 100,
    "iso_code": "mmk",
    "name": "Myanmar Kyat",
    "symbol": "K",
    "alternate_symbols": [],
    "subunit": "Pya",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "104",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mnt": {
    "priority": 100,
    "iso_code": "mnt",
    "name": "Mongolian Tögrög",
    "symbol": "₮",
    "alternate_symbols": [],
    "subunit": "Möngö",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x20AE;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "496",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mop": {
    "priority": 100,
    "iso_code": "mop",
    "name": "Macanese Pataca",
    "symbol": "P",
    "alternate_symbols": [
      "MOP$"
    ],
    "subunit": "Avo",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "446",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mro": {
    "priority": 100,
    "iso_code": "mro",
    "name": "Mauritanian Ouguiya",
    "symbol": "UM",
    "alternate_symbols": [],
    "subunit": "Khoums",
    "subunit_to_unit": 5,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "478",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mur": {
    "priority": 100,
    "iso_code": "mur",
    "name": "Mauritian Rupee",
    "symbol": "₨",
    "alternate_symbols": [],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20A8;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "480",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mvr": {
    "priority": 100,
    "iso_code": "mvr",
    "name": "Maldivian Rufiyaa",
    "symbol": "MVR",
    "alternate_symbols": [
      "MRF",
      "Rf",
      "/-",
      "ރ"
    ],
    "subunit": "Laari",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "462",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mwk": {
    "priority": 100,
    "iso_code": "mwk",
    "name": "Malawian Kwacha",
    "symbol": "MK",
    "alternate_symbols": [],
    "subunit": "Tambala",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "454",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mxn": {
    "priority": 100,
    "iso_code": "mxn",
    "name": "Mexican Peso",
    "symbol": "$",
    "alternate_symbols": [
      "MEX$"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "484",
    "subunit_symbol": "¢",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "myr": {
    "priority": 100,
    "iso_code": "myr",
    "name": "Malaysian Ringgit",
    "symbol": "RM",
    "alternate_symbols": [],
    "subunit": "Sen",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "458",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mzn": {
    "priority": 100,
    "iso_code": "mzn",
    "name": "Mozambican Metical",
    "symbol": "MTn",
    "alternate_symbols": [
      "MZN"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "943",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "nad": {
    "priority": 100,
    "iso_code": "nad",
    "name": "Namibian Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "N$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "516",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ngn": {
    "priority": 100,
    "iso_code": "ngn",
    "name": "Nigerian Naira",
    "symbol": "₦",
    "alternate_symbols": [],
    "subunit": "Kobo",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x20A6;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "566",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "nio": {
    "priority": 100,
    "iso_code": "nio",
    "name": "Nicaraguan Córdoba",
    "symbol": "C$",
    "alternate_symbols": [],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "558",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "nok": {
    "priority": 100,
    "iso_code": "nok",
    "name": "Norwegian Krone",
    "symbol": "kr",
    "alternate_symbols": [
      ",-"
    ],
    "subunit": "Øre",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "kr",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "578",
    "subunit_symbol": "",
    "postfixed_symbol": true,
    "payout_no_decimal": false
  },
  "npr": {
    "priority": 100,
    "iso_code": "npr",
    "name": "Nepalese Rupee",
    "symbol": "₨",
    "alternate_symbols": [
      "Rs",
      "रू"
    ],
    "subunit": "Paisa",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20A8;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "524",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "nzd": {
    "priority": 100,
    "iso_code": "nzd",
    "name": "New Zealand Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "NZ$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "554",
    "subunit_symbol": "c",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "omr": {
    "priority": 100,
    "iso_code": "omr",
    "name": "Omani Rial",
    "symbol": "ر.ع.",
    "alternate_symbols": [],
    "subunit": "Baisa",
    "subunit_to_unit": 1000,
    "symbol_first": true,
    "html_entity": "\u0026#xFDFC;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "512",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "pab": {
    "priority": 100,
    "iso_code": "pab",
    "name": "Panamanian Balboa",
    "symbol": "B/.",
    "alternate_symbols": [],
    "subunit": "Centésimo",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "590",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "pen": {
    "priority": 100,
    "iso_code": "pen",
    "name": "Peruvian Nuevo Sol",
    "symbol": "S/.",
    "alternate_symbols": [],
    "subunit": "Céntimo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "S/.",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "604",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "pgk": {
    "priority": 100,
    "iso_code": "pgk",
    "name": "Papua New Guinean Kina",
    "symbol": "K",
    "alternate_symbols": [],
    "subunit": "Toea",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "598",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "php": {
    "priority": 100,
    "iso_code": "php",
    "name": "Philippine Peso",
    "symbol": "₱",
    "alternate_symbols": [
      "PHP",
      "PhP",
      "P"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20B1;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "608",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "pkr": {
    "priority": 100,
    "iso_code": "pkr",
    "name": "Pakistani Rupee",
    "symbol": "₨",
    "alternate_symbols": [
      "Rs"
    ],
    "subunit": "Paisa",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20A8;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "586",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "pln": {
    "priority": 100,
    "iso_code": "pln",
    "name": "Polish Złoty",
    "symbol": "zł",
    "alternate_symbols": [],
    "subunit": "Grosz",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "z\u0026#322;",
    "decimal_mark": ",",
    "thousands_separator": " ",
    "iso_numeric": "985",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "pyg": {
    "priority": 100,
    "iso_code": "pyg",
    "name": "Paraguayan Guaraní",
    "symbol": "₲",
    "alternate_symbols": [],
    "subunit": "Céntimo",
    "subunit_to_unit": 1,
    "symbol_first": true,
    "html_entity": "\u0026#x20B2;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "600",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "qar": {
    "priority": 100,
    "iso_code": "qar",
    "name": "Qatari Riyal",
    "symbol": "ر.ق",
    "alternate_symbols": [
      "QR"
    ],
    "subunit": "Dirham",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#xFDFC;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "634",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ron": {
    "priority": 100,
    "iso_code": "ron",
    "name": "Romanian Leu",
    "symbol": "Lei",
    "alternate_symbols": [],
    "subunit": "Bani",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "946",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "rsd": {
    "priority": 100,
    "iso_code": "rsd",
    "name": "Serbian Dinar",
    "symbol": "РСД",
    "alternate_symbols": [
      "RSD",
      "din",
      "дин"
    ],
    "subunit": "Para",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "941",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "rub": {
    "priority": 100,
    "iso_code": "rub",
    "name": "Russian Ruble",
    "symbol": "р.",
    "alternate_symbols": [
      "руб"
    ],
    "subunit": "Kopek",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x0440;\u0026#x0443;\u0026#x0431;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "643",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "rwf": {
    "priority": 100,
    "iso_code": "rwf",
    "name": "Rwandan Franc",
    "symbol": "FRw",
    "alternate_symbols": [
      "RF",
      "R₣"
    ],
    "subunit": "Centime",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "646",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "sar": {
    "priority": 100,
    "iso_code": "sar",
    "name": "Saudi Riyal",
    "symbol": "ر.س",
    "alternate_symbols": [
      "SR",
      "﷼"
    ],
    "subunit": "Hallallah",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#xFDFC;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "682",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "sbd": {
    "priority": 100,
    "iso_code": "sbd",
    "name": "Solomon Islands Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "SI$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "090",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "scr": {
    "priority": 100,
    "iso_code": "scr",
    "name": "Seychellois Rupee",
    "symbol": "₨",
    "alternate_symbols": [
      "SRe",
      "SR"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x20A8;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "690",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "sdg": {
    "priority": 100,
    "iso_code": "sdg",
    "name": "Sudanese Pound",
    "symbol": "£",
    "alternate_symbols": [],
    "subunit": "Piastre",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "938",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "sek": {
    "priority": 100,
    "iso_code": "sek",
    "name": "Swedish Krona",
    "symbol": "kr",
    "alternate_symbols": [
      ":-"
    ],
    "subunit": "Öre",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": " ",
    "iso_numeric": "752",
    "subunit_symbol": "",
    "postfixed_symbol": true,
    "payout_no_decimal": false
  },
  "sgd": {
    "priority": 100,
    "iso_code": "sgd",
    "name": "Singapore Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "S$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "702",
    "subunit_symbol": "¢",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "shp": {
    "priority": 100,
    "iso_code": "shp",
    "name": "Saint Helenian Pound",
    "symbol": "£",
    "alternate_symbols": [],
    "subunit": "Penny",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "654",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "skk": {
    "priority": 100,
    "iso_code": "skk",
    "name": "Slovak Koruna",
    "symbol": "Sk",
    "alternate_symbols": [],
    "subunit": "Halier",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "703",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "sll": {
    "priority": 100,
    "iso_code": "sll",
    "name": "Sierra Leonean Leone",
    "symbol": "Le",
    "alternate_symbols": [],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "694",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "sos": {
    "priority": 100,
    "iso_code": "sos",
    "name": "Somali Shilling",
    "symbol": "Sh",
    "alternate_symbols": [
      "Sh.So"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "706",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "srd": {
    "priority": 100,
    "iso_code": "srd",
    "name": "Surinamese Dollar",
    "symbol": "$",
    "alternate_symbols": [],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "968",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ssp": {
    "priority": 100,
    "iso_code": "shp",
    "name": "South Sudanese Pound",
    "symbol": "£",
    "alternate_symbols": [],
    "subunit": "piaster",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "728",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "std": {
    "priority": 100,
    "iso_code": "std",
    "name": "São Tomé and Príncipe Dobra",
    "symbol": "Db",
    "alternate_symbols": [],
    "subunit": "Cêntimo",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "678",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "svc": {
    "priority": 100,
    "iso_code": "svc",
    "name": "Salvadoran Colón",
    "symbol": "₡",
    "alternate_symbols": [
      "¢"
    ],
    "subunit": "Centavo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20A1;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "222",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "syp": {
    "priority": 100,
    "iso_code": "syp",
    "name": "Syrian Pound",
    "symbol": "£S",
    "alternate_symbols": [
      "£",
      "ل.س",
      "LS",
      "الليرة السورية"
    ],
    "subunit": "Piastre",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "760",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "szl": {
    "priority": 100,
    "iso_code": "szl",
    "name": "Swazi Lilangeni",
    "symbol": "L",
    "alternate_symbols": [
      "E"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "748",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "thb": {
    "priority": 100,
    "iso_code": "thb",
    "name": "Thai Baht",
    "symbol": "฿",
    "alternate_symbols": [],
    "subunit": "Satang",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x0E3F;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "764",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "tjs": {
    "priority": 100,
    "iso_code": "tjs",
    "name": "Tajikistani Somoni",
    "symbol": "ЅМ",
    "alternate_symbols": [],
    "subunit": "Diram",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "972",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "tmt": {
    "priority": 100,
    "iso_code": "tmm",
    "name": "Turkmenistani Manat",
    "symbol": "m",
    "alternate_symbols": [],
    "subunit": "Tennesi",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "934",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "tnd": {
    "priority": 100,
    "iso_code": "tnd",
    "name": "Tunisian Dinar",
    "symbol": "د.ت",
    "alternate_symbols": [
      "TD",
      "DT"
    ],
    "subunit": "Millime",
    "subunit_to_unit": 1000,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "788",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "top": {
    "priority": 100,
    "iso_code": "top",
    "name": "Tongan Paʻanga",
    "symbol": "T$",
    "alternate_symbols": [
      "PT"
    ],
    "subunit": "Seniti",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "776",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "try": {
    "priority": 100,
    "iso_code": "try",
    "name": "Turkish Lira",
    "symbol": "TL",
    "alternate_symbols": [],
    "subunit": "kuruş",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "949",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ttd": {
    "priority": 100,
    "iso_code": "ttd",
    "name": "Trinidad and Tobago Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "TT$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "780",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "twd": {
    "priority": 100,
    "iso_code": "twd",
    "name": "New Taiwan Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "NT$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "901",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": true
  },
  "tzs": {
    "priority": 100,
    "iso_code": "tzs",
    "name": "Tanzanian Shilling",
    "symbol": "Sh",
    "alternate_symbols": [],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "834",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "uah": {
    "priority": 100,
    "iso_code": "uah",
    "name": "Ukrainian Hryvnia",
    "symbol": "₴",
    "alternate_symbols": [],
    "subunit": "Kopiyka",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#x20B4",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "980",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ugx": {
    "priority": 100,
    "iso_code": "ugx",
    "name": "Ugandan Shilling",
    "symbol": "USh",
    "alternate_symbols": [],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "800",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "usd": {
    "priority": 1,
    "iso_code": "usd",
    "name": "United States Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "US$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "840",
    "subunit_symbol": "¢",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "uyu": {
    "priority": 100,
    "iso_code": "uyu",
    "name": "Uruguayan Peso",
    "symbol": "$",
    "alternate_symbols": [
      "$U"
    ],
    "subunit": "Centésimo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x20B1;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "858",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "uzs": {
    "priority": 100,
    "iso_code": "uzs",
    "name": "Uzbekistani Som",
    "symbol": "лв",
    "alternate_symbols": [],
    "subunit": "Tiyin",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "860",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "vef": {
    "priority": 100,
    "iso_code": "vef",
    "name": "Venezuelan Bolívar",
    "symbol": "Bs F",
    "alternate_symbols": [
      "Bs.F",
      "Bs"
    ],
    "subunit": "Céntimo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "937",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "vnd": {
    "priority": 100,
    "iso_code": "vnd",
    "name": "Vietnamese Đồng",
    "symbol": "₫",
    "alternate_symbols": [],
    "subunit": "Hào",
    "subunit_to_unit": 1,
    "symbol_first": true,
    "html_entity": "\u0026#x20AB;",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "704",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "vuv": {
    "priority": 100,
    "iso_code": "vuv",
    "name": "Vanuatu Vatu",
    "symbol": "Vt",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "548",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "wst": {
    "priority": 100,
    "iso_code": "wst",
    "name": "Samoan Tala",
    "symbol": "T",
    "alternate_symbols": [
      "WS$",
      "SAT",
      "ST"
    ],
    "subunit": "Sene",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "882",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "xaf": {
    "priority": 100,
    "iso_code": "xaf",
    "name": "Central African Cfa Franc",
    "symbol": "Fr",
    "alternate_symbols": [
      "FCFA"
    ],
    "subunit": "Centime",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "950",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "xag": {
    "priority": 100,
    "iso_code": "xag",
    "name": "Silver (Troy Ounce)",
    "symbol": "oz t",
    "alternate_symbols": [],
    "subunit": "oz",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "961",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "xau": {
    "priority": 100,
    "iso_code": "xau",
    "name": "Gold (Troy Ounce)",
    "symbol": "oz t",
    "alternate_symbols": [],
    "subunit": "oz",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "959",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "xcd": {
    "priority": 100,
    "iso_code": "xcd",
    "name": "East Caribbean Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "EC$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "951",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "xdr": {
    "priority": 100,
    "iso_code": "xdr",
    "name": "Special Drawing Rights",
    "symbol": "SDR",
    "alternate_symbols": [
      "XDR"
    ],
    "subunit": "",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "960",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "xof": {
    "priority": 100,
    "iso_code": "xof",
    "name": "West African Cfa Franc",
    "symbol": "Fr",
    "alternate_symbols": [
      "CFA"
    ],
    "subunit": "Centime",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "952",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "xpf": {
    "priority": 100,
    "iso_code": "xpf",
    "name": "Cfp Franc",
    "symbol": "Fr",
    "alternate_symbols": [
      "F"
    ],
    "subunit": "Centime",
    "subunit_to_unit": 1,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "953",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "yer": {
    "priority": 100,
    "iso_code": "yer",
    "name": "Yemeni Rial",
    "symbol": "﷼",
    "alternate_symbols": [],
    "subunit": "Fils",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "\u0026#xFDFC;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "886",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "zar": {
    "priority": 100,
    "iso_code": "zar",
    "name": "South African Rand",
    "symbol": "R",
    "alternate_symbols": [],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x0052;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "710",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "zmk": {
    "priority": 100,
    "iso_code": "zmk",
    "name": "Zambian Kwacha",
    "symbol": "ZK",
    "alternate_symbols": [],
    "subunit": "Ngwee",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "894",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "zmw": {
    "priority": 100,
    "iso_code": "zmw",
    "name": "Zambian Kwacha",
    "symbol": "ZK",
    "alternate_symbols": [],
    "subunit": "Ngwee",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "967",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "btc": {
    "priority": 100,
    "iso_code": "btc",
    "name": "Bitcoin",
    "symbol": "B⃦",
    "alternate_symbols": [],
    "subunit": "Satoshi",
    "subunit_to_unit": 100000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "jep": {
    "priority": 100,
    "iso_code": "jep",
    "name": "Jersey Pound",
    "symbol": "£",
    "alternate_symbols": [],
    "subunit": "Penny",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "eek": {
    "priority": 100,
    "iso_code": "eek",
    "name": "Estonian Kroon",
    "symbol": "KR",
    "alternate_symbols": [],
    "subunit": "Sent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "233",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ghc": {
    "priority": 100,
    "iso_code": "ghc",
    "name": "Ghanaian Cedi",
    "symbol": "₵",
    "disambiguate_symbol": "GHC",
    "alternate_symbols": [],
    "subunit": "Pesewa",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "288",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mtl": {
    "priority": 100,
    "iso_code": "mtl",
    "name": "Maltese Lira",
    "symbol": "₤",
    "alternate_symbols": [
      "Lm"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x00A3;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "470",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "tmm": {
    "priority": 100,
    "iso_code": "tmm",
    "name": "Turkmenistani Manat",
    "symbol": "m",
    "alternate_symbols": [],
    "subunit": "Tennesi",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "795",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "yen": {
    "priority": 100,
    "iso_code": "jpy",
    "name": "Japanese Yen",
    "symbol": "¥",
    "alternate_symbols": [
      "円",
      "圓"
    ],
    "subunit": "Sen",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "\u0026#x00A5;",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "zwd": {
    "priority": 100,
    "iso_code": "zwd",
    "name": "Zimbabwean Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "Z$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "716",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "zwl": {
    "priority": 100,
    "iso_code": "zwl",
    "name": "Zimbabwean Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "Z$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "932",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "zwn": {
    "priority": 100,
    "iso_code": "zwn",
    "name": "Zimbabwean Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "Z$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "942",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "zwr": {
    "priority": 100,
    "iso_code": "zwr",
    "name": "Zimbabwean Dollar",
    "symbol": "$",
    "alternate_symbols": [
      "Z$"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "$",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "935",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "eurc": {
    "priority": 100,
    "iso_code": "eurc",
    "name": "EURC",
    "symbol": "€",
    "disambiguate_symbol": "EURC",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "ves": {
    "priority": 100,
    "iso_code": "ves",
    "name": "Venezuelan bolívar soberano",
    "symbol": "Bs",
    "alternate_symbols": [
      "Bs.S"
    ],
    "subunit": "céntimo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "928",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "mru": {
    "priority": 100,
    "iso_code": "mru",
    "name": "Mauritanian Ouguiya",
    "symbol": "UM",
    "alternate_symbols": [],
    "subunit": "Khoums",
    "subunit_to_unit": 5,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ".",
    "iso_numeric": "929",
    "smallest_denomination": 1,
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "byn": {
    "priority": 100,
    "iso_code": "byn",
    "name": "Belarusian Ruble",
    "symbol": "Br",
    "disambiguate_symbol": "BYN",
    "alternate_symbols": [
      "бел. руб.",
      "б.р.",
      "руб.",
      "р."
    ],
    "subunit": "Kapeyka",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": " ",
    "iso_numeric": "933",
    "smallest_denomination": 1,
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "sle": {
    "priority": 100,
    "iso_code": "sle",
    "name": "Sierra Leonean leone",
    "symbol": "Le",
    "disambiguate_symbol": "Le",
    "alternate_symbols": [],
    "subunit": "cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "925",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "stn": {
    "priority": 100,
    "iso_code": "stn",
    "name": "Dobra",
    "symbol": "Stn",
    "disambiguate_symbol": "STN",
    "alternate_symbols": [
      "Db"
    ],
    "subunit": "céntimo",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "930",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "usdc": {
    "priority": 100,
    "iso_code": "usdc",
    "name": "USD Coin",
    "symbol": "$",
    "disambiguate_symbol": "USDC",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "usdb": {
    "priority": 100,
    "iso_code": "usdb",
    "name": "USD Bridge",
    "symbol": "$",
    "disambiguate_symbol": "USDB",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "zwg": {
    "priority": 100,
    "iso_code": "zwg",
    "name": "Zimbabwe Gold",
    "symbol": "ZWG",
    "alternate_symbols": [
      "ZiG"
    ],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "924",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "xcg": {
    "priority": 100,
    "iso_code": "xcg",
    "name": "Caribbean Guilder",
    "symbol": "Cg",
    "alternate_symbols": [],
    "subunit": "Cent",
    "subunit_to_unit": 100,
    "symbol_first": false,
    "html_entity": "",
    "decimal_mark": ",",
    "thousands_separator": ".",
    "iso_numeric": "532",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "arb": {
    "priority": 100,
    "iso_code": "arb",
    "name": "Arbitrum",
    "symbol": "ARB",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000000000000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "avax": {
    "priority": 100,
    "iso_code": "avax",
    "name": "Avalanche",
    "symbol": "AVAX",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000000000000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "dai": {
    "priority": 100,
    "iso_code": "dai",
    "name": "Dai",
    "symbol": "DAI",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000000000000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "eth": {
    "priority": 100,
    "iso_code": "eth",
    "name": "Ether",
    "symbol": "ETH",
    "alternate_symbols": [],
    "subunit": "wei",
    "subunit_to_unit": 1000000000000000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "pol": {
    "priority": 100,
    "iso_code": "pol",
    "name": "Polygon Ecosystem Token",
    "symbol": "POL",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000000000000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "pyusd": {
    "priority": 100,
    "iso_code": "pyusd",
    "name": "PayPal USD",
    "symbol": "$",
    "disambiguate_symbol": "PYUSD",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "sol": {
    "priority": 100,
    "iso_code": "sol",
    "name": "Solana",
    "symbol": "SOL",
    "alternate_symbols": [],
    "subunit": "lamport",
    "subunit_to_unit": 1000000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "trx": {
    "priority": 100,
    "iso_code": "trx",
    "name": "Tronix",
    "symbol": "TRX",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "usdp": {
    "priority": 100,
    "iso_code": "usdp",
    "name": "Pax Dollar",
    "symbol": "$",
    "disambiguate_symbol": "USDP",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  },
  "usdt": {
    "priority": 100,
    "iso_code": "usdt",
    "name": "Tether",
    "symbol": "$",
    "disambiguate_symbol": "USDT",
    "alternate_symbols": [],
    "subunit": null,
    "subunit_to_unit": 1000000,
    "symbol_first": true,
    "html_entity": "",
    "decimal_mark": ".",
    "thousands_separator": ",",
    "iso_numeric": "",
    "subunit_symbol": "",
    "postfixed_symbol": false,
    "payout_no_decimal": false
  }
};

export default CURRENCIES;
